
/**
 * GridStylesProcessor - Creates styles for grid layouts
 */
export class GridStylesProcessor {
  static createGridStyles(): string {
    return `
      /* Grid layouts for all selection cards */
      .onexip-calculator-container .grid {
        display: grid !important;
        gap: 1rem !important;
      }

      .onexip-calculator-container .grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
      }

      @media (min-width: 768px) {
        .onexip-calculator-container .md\\:grid-cols-2,
        .onexip-calculator-container .md\\:grid-cols-3,
        .onexip-calculator-container .md\\:grid-cols-4 {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }
      }
    `;
  }
}
